
export default function PartnersSection() {
  const partners = [
    {
      id: 1,
      name: 'V5med',
      type: 'Healthcare Technology',
      description: 'Leading medical technology company specializing ...',
      logo: 'https://public.readdy.ai/ai/img_res/7263e19f1161e7f4044f6d218b1e6d65.jpg',
      website: 'www.v5med.com',
      employees: '200+',
      founded: 2018,
      location: 'San Francisco, CA',
      learnMoreUrl: 'https://www.v5med.com/en/archives/213'
    },
    {
      id: 2,
      name: 'Liexl',
      type: 'Data Analytics',
      description: 'Advanced data analytics and business intelligence platform providing actionable insights for enterprise decision-making.',
      logo: 'https://readdy.ai/api/search-image?query=Modern%20data%20analytics%20company%20logo%20with%20geometric%20patterns%20and%20data%20visualization%20elements%2C%20blue%20and%20purple%20gradient%20colors%2C%20professional%20tech%20branding%2C%20clean%20corporate%20style&width=120&height=120&seq=liexl-logo&orientation=squarish',
      website: 'www.liexl.com',
      employees: '180+',
      founded: 2019,
      location: 'Austin, TX'
    },
    {
      id: 3,
      name: 'CancerFree Biotech',
      type: 'Biotechnology',
      description: 'Pioneering biotechnology company focused on developing breakthrough cancer treatment therapies and diagnostic solutions.',
      logo: 'https://readdy.ai/api/search-image?query=Biotechnology%20company%20logo%20with%20DNA%20helix%20and%20medical%20research%20elements%2C%20green%20and%20blue%20colors%20representing%20health%20and%20science%2C%20professional%20pharmaceutical%20branding%2C%20modern%20scientific%20design&width=120&height=120&seq=cancerfree-logo&orientation=squarish',
      website: 'www.cancerfree-biotech.com',
      employees: '120+',
      founded: 2020,
      location: 'Boston, MA'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Our Partner Companies
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We collaborate with industry-leading companies to provide comprehensive business solutions and accelerate growth opportunities for our network members.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {partners.map((partner) => (
            <div key={partner.id} className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-all duration-300 hover:border-blue-200">
              <div className="flex items-start gap-6 mb-6">
                <div className="flex-shrink-0">
                  <img
                    src={partner.logo}
                    alt={`${partner.name} logo`}
                    className="w-20 h-20 rounded-lg object-cover border border-gray-100"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{partner.name}</h3>
                  <div className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium mb-3">
                    {partner.type}
                  </div>
                  <p className="text-gray-600 leading-relaxed">
                    {partner.description}
                  </p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="flex items-center gap-3 text-gray-600">
                  <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center text-blue-600"></i>
                  <span className="text-sm">{partner.location}</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600">
                  <i className="ri-user-line w-5 h-5 flex items-center justify-center text-blue-600"></i>
                  <span className="text-sm">{partner.employees} employees</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600">
                  <i className="ri-global-line w-5 h-5 flex items-center justify-center text-blue-600"></i>
                  <span className="text-sm">{partner.website}</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600">
                  <i className="ri-calendar-line w-5 h-5 flex items-center justify-center text-blue-600"></i>
                  <span className="text-sm">Founded {partner.founded}</span>
                </div>
              </div>
              
              <div className="flex gap-3">
                {partner.learnMoreUrl ? (
                  <a 
                    href={partner.learnMoreUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer text-center"
                  >
                    Learn More
                  </a>
                ) : (
                  <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer">
                    Learn More
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-gray-50 rounded-xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Become a Partner
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Join our network of innovative companies and expand your business reach. Partner with us to access new markets, collaborate on projects, and drive mutual growth.
            </p>
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Apply for Partnership
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
